// extracted by css-extract-rspack-plugin
export default {"CompactCommentInputContainer":"CompactCommentButton-module__CompactCommentInputContainer__Ab_eI"};